/**
 * @fileoverview Hook responsável por buscar os indicadores consolidados do dashboard.
 */

import { useCallback } from "react";
import api from "../../services/api";

const useDashboard = () => {

    const find = useCallback(async (params) => {
        const { data } = await api.request({
            url: `/dashboard`,
            method: 'GET',
            params
        });
        return data;
    }, []);

    return {
        find
    }
}

export default useDashboard;
